<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Квоты') }} > {{ $t('Аннулирование квоты') }}</h1>
    <div class="my-organization">
      <div v-cloak class="quotas-pg create-quota-pg bgw-pdg-20">
        <h4 class="text-center">{{ $t('Аннулирование квоты на добычу диких животных') }}</h4>
        <v-form ref="form" @submit.prevent="updateQuotaCancellation" lazy-validation>
          <!--таблица-->
          <div v-if="faunaQuotas.length" class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td>{{ $t('Вид животного') }}</td>
                <td class="text-center">{{ $t('Лимит') }}</td>
                <td class="text-center">{{ $t('Кол-во гол. выданных ранее') }}</td>
                <td class="text-center">{{ $t('Кол-во использованных') }}</td>
                <td class="text-center">{{ $t('Аннулировать голов') }}</td>
                <td class="text-center">{{ $t('Действие') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in faunaQuotas" :key="item.id">
                <td>{{ item.faunaName }}</td>
                <td class="text-center">{{ item.limitHeadQuantity }}</td>
                <td class="text-center">{{ item.limitHeadQuantityQuota }}</td>
                <td class="text-center">0</td>
                <td class="text-center">
                  <div :class="{ invalid: $v.faunaQuota.headCount.$error && !item.headCount }">
                    <v-text-field
                      v-model="item.headCount"
                      type="number"
                      outlined
                      dense
                      class="size-small hide-arrows"
                      @change="faunaCountHandler"
                    />
                  </div>
                </td>
                <td class="td-action text-center">
                  <v-btn v-if="faunaQuotas.length > 1" class="btn-delete" @click.native.stop="deleteQuota(item.id)">
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!--Реквизиты документа - Дата-->
          <div class="form-group">
            <div class="quota-fields justify-space-between align-start">
              <div class="quota-field textarea-field">
                <label>{{ $t('Реквизиты документа') }}:</label>
                <v-textarea
                  v-model="quotaCancellation.documentDetails"
                  outlined
                  dense
                  class="size-small"
                />
              </div>
              <div class="quota-field datepicker-main" :class="{ invalid: $v.quotaCancellation.date.$error }">
                <label>{{ $t('Дата') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    v-model="quotaCancellation.date"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="$t('Дата')"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--Файл-->
          <div class="form-group">
            <div class="quota-fields">
              <template v-if="quotaCancellation.file">
                <div class="quota-field">
                  <template
                    v-if="checkFileExist(quotaCancellation.fileExtension)"
                  >
                    <a
                      @click="previewDocumentDialog(quotaCancellation.id, true)"
                    >{{ $t('Файл документа') }}</a>
                    <v-dialog
                      v-model="previewDocsModal[quotaCancellation.id]"
                      max-width="1200"
                    >
                      <v-card class="modal">
                        <div class="modal-head">
                          {{ $t('Файл документа') }}
                          <v-btn
                            color="modal-close"
                            @click="previewDocumentDialog(quotaCancellation.id, false)"
                          >
                            <img src="@/assets/img/close-icon.png" alt="icon">
                          </v-btn>
                        </div>
                        <div class="modal-body">
                          <VueDocPreview
                            :value="backUrl + quotaCancellation.file"
                            type="office"
                          />
                        </div>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-else>
                    <a
                      :href="backUrl + quotaCancellation.file"
                      target="_blank"
                    >{{ $t('Файл документа') }}</a>
                  </template>
                </div>
                <div class="quota-field">
                  <a href="#" class="file-delete" @click="deleteFile">{{ $t('Удалить') }}</a>
                </div>
              </template>
              <div class="quota-field">
                <div class="file-input-link upload-file">
                  <v-file-input
                    :label="$t('Загрузить файл документа')"
                    v-model="quotaCancellationFile"
                    clearable
                    ref="file"
                    @change="handleFileUpload()"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--Комментарии-->
          <div class="form-group">
            <div class="comment-field">
              <label>{{ $t('Комментарии') }}:</label>
              <v-textarea
                v-model="quotaCancellation.comment"
                outlined
                dense
                class="size-small"
              />
            </div>
          </div>
          <!--кнопки действии-->
          <div class="form-action">
            <button
              class="btn btn-default blue"
              type="submit"
              @click="statusId = draftStatus"
            >
              {{ $t('Сохранить') }}
            </button>
            <button
              class="btn btn-default blue"
              type="submit"
              @click="statusId = approvedStatus"
            >
              {{ $t('Сохранить и утвердить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Quota from '@/model/quota'
import VueDocPreview from 'vue-doc-preview'

export default {
  components: {
    VueDocPreview
  },
  data: () => ({
    breadcrumbs: [],
    quotaCancellation: {},
    faunaQuotas: [],
    file: '',
    quotaCancellationFile: null,
    backUrl: process.env.VUE_APP_BACK_URL,
    previewDocsModal: [],
    rules: {
      quotaCancellation: {
        date: { required }
      },
      faunaQuota: {
        headCount: {}
      }
    },
    draftStatus: null,
    approvedStatus: null,
    statusId: null,
    faunaQuotaValidateState: false
  }),
  validations () {
    if (!this.faunaQuotaValidate) {
      this.rules.faunaQuota.headCount = { required }
    } else {
      this.rules.faunaQuota.headCount = {}
    }
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  computed: {
    faunaQuotaValidate () {
      return this.faunaQuotaValidateState
    },
    minDate () {
      const year = this.quotaCancellation.year ? this.quotaCancellation.year.year : new Date().getFullYear()
      return year + '-01-01'
    },
    maxDate () {
      const year = this.quotaCancellation.year ? this.quotaCancellation.year.year : new Date().getFullYear()
      return year + '-12-31'
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.getQuotaCanceledInfo(this.$route.params.id).then((response) => {
        this.quotaCancellation = response.data
        this.faunaQuotas = this.quotaCancellation.quotas
        this.draftStatus = this.quotaCancellation.draftStatus
        this.approvedStatus = this.quotaCancellation.approvedStatus
        this.generateBreadcrumbs()
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.setLoading(false)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Квота'),
          disabled: false,
          href: '/quota-cancellation-view/' + this.$route.params.id
        },
        {
          text: this.$i18n.t('Аннулирование квоты на добычу диких животных'),
          disabled: true
        }
      ]
    },
    // Сохранение
    updateQuotaCancellation () {
      // проверяем на заполнение полей faunaQuota
      this.faunaQuotas.forEach(element => {
        if (element.headCount !== '') {
          this.faunaQuotaValidateState = true
        } else {
          this.faunaQuotaValidateState = false
        }
      })
      if (!this.validateForm()) {
        return
      }
      const result = []
      this.faunaQuotas.map(element => {
        if (element.headCount > 0) {
          result.push({
            id: element.fauna,
            count: element.headCount
          })
        }
      })
      if (this.faunaQuotas.length !== result.length) {
        this.$noty.error(this.$i18n.t('Все поля "Аннулировать голов" должны быть больше 0'), {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
        return
      }

      this.setLoading(true)

      const formEl = this.$refs.form.$el
      const fd = new FormData(formEl)
      fd.append('quota_canceled[documentDetails]', this.quotaCancellation.documentDetails)
      fd.append('quota_canceled[date]', this.quotaCancellation.date)
      fd.append('quota_canceled[uploadedFile]', this.quotaCancellationFile)
      fd.append('quota_canceled[comment]', this.quotaCancellation.comment)

      result.forEach(function (element, index) {
        fd.append('faunas[' + index + '][id]', element.id)
        fd.append('faunas[' + index + '][count]', element.count)
      })

      Quota.editCancelQuotas(this.$route.params.id, this.statusId, fd).then((response) => {
        this.onCancel()
        this.setLoading(false)
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        this.setLoading(false)
      })
    },
    // Удаление квоты
    deleteQuota (id) {
      console.log('delete id', id)
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        Quota.deleteQuota(id)
          .then((response) => {
            this.faunaQuotas = response.data.quotas
            this.setLoading(false)
          })
          .catch((error) => {
            console.log(error)
            this.setLoading(false)
          })
      }
    },
    // Удаление файла
    deleteFile () {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        Quota.deleteQuotaCanceledFile(this.quotaCancellation.id)
          .then((response) => {
            if (response.status === 200) this.quotaCancellation.file = null
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    // проверяем поле "аннулировать голов" поле не должно быть меньше 0 и превышать "количество выданных ранее"
    faunaCountHandler () {
      this.faunaQuotas.forEach((element) => {
        if (element.headCount > element.limitHeadQuantityQuota) {
          element.headCount = element.limitHeadQuantityQuota
          this.$noty.error(this.$i18n.t('Количество аннулировать голов не должно превышать, количество выданных ранее'), {
            killer: true,
            timeout: 2000,
            layout: 'topRight'
          })
        }
        if (element.headCount < 0) {
          element.headCount = 0
        }
      })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    handleFileUpload () {
      this.file = ''

      if (this.quotaCancellationFile) {
        this.createFile(this.quotaCancellationFile)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'quota-cancellation-view',
        params: {
          id: this.$route.params.id
        }
      })
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-head {
  margin-bottom: 20px;
}

.table-overflow {
  margin-bottom: 30px;

  table {
    td {
      .v-input {
        margin: 0 auto;
      }
    }
  }
}
</style>
